import React, { useEffect, useContext, useState } from 'react';
import RegionalMarketingItems from '../Presentation/RegionalMarketingItems';
import {
  modifyData,
  orderBtnAnalytics,
  clickImageAnalytics,
  getFilteredCarausalData,
} from '../MarketingUtilities/marketingUtils';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import { UserOrderContext } from '../../../context/context';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isMobileDevice } from '../../../common/utilities/utils';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
const { CAROUSEL_IMAGE_CLICK } = MARKETING_HERO_CONSTANTS;
export const analyticsImageClick = (analyticsData, index, item, currencyShortName, orderNowClick) => {
  clickImageAnalytics(analyticsData, index, item, currencyShortName);
  orderNowClick(analyticsData, index, CAROUSEL_IMAGE_CLICK, item);
};
export const RegionalMarketingComponent = props => {
  const { contentData = {}, history } = props;
  const { carousalContent = '', animationSpeed } = contentData;
  const { SELECTED_TILE_DATA } = START_ORDER_CONSTANTS;
  const dispositionNew = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW));
  const type = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE);
  const { store } = dispositionNew?.store ? dispositionNew : MARKETING_HERO_CONSTANTS?.localizedUserSampleData;
  const { id: storeId = '', name } = store;
  const { value: storeName = '' } = name[0];
  const filteredCarouselContent =
    (carousalContent && getFilteredCarausalData(carousalContent, type, storeId, storeName)) ?? [];
  const carouselContentData = filteredCarouselContent && modifyData(filteredCarouselContent);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  /**
   * Method calls on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listener for window size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const orderNowClick = (analyticsData, index, clickFlag, item) => {
    if (clickFlag !== CAROUSEL_IMAGE_CLICK) {
      clickImageAnalytics(analyticsData, index);
    }

    orderBtnAnalytics(analyticsData, index);
    userOrderStateDispatch({
      type: SELECTED_TILE_DATA,
      value: {
        selectedData: {
          name: item.name,
        },
      },
    });
    localStorage.setItem(
      'selectedTile',
      JSON.stringify({
        name: item.name,
      }),
    );
    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
    //selected tile from setState
    //setSelectedMenu(item);
    //call menu api dispatch
    // dispatch(
    //     fetchRecommendationsAction({ tenantId: tenantReducer.tenantId, catalogName: 'KFCIndiaMenu_129_D_1001' })
    // );
    //check if localized then call exclusion api dispatch
    // if (userOrderState && userOrderState.scheduleOrderData && userOrderState.scheduleOrderData.storeInfo
    //     && isEmptyObject(userOrderState.scheduleOrderData.storeInfo)) {
    //     const { dispositionType } = userOrderState.dispositionStateData;
    //     let serviceType = '';
    //     switch (dispositionType.toUpperCase()) {
    //         case TYPE_DELIVERY:
    //             serviceType = dispositionType;
    //             break;
    //         case TYPE_TAKE_WAY:
    //             serviceType = PICK_UP;
    //             break;
    //         case TYPE_DINE_IN:
    //             serviceType = DINE_IN;
    //             break;
    //     }
    //     const { id } = userOrderState.scheduleOrderData.storeInfo;
    //     dispatch(
    //         fetchExclusionAction({ storeId: id, channel: 'web', service: serviceType })
    //     );

    // }
    history.push({
      pathname: `${item.linkTo}`, //use linkTo
    });
  };

  return (
    <div className='market-hero marketing-hero-in'>
      {carouselContentData && (
        <RegionalMarketingItems
          contentData={carouselContentData}
          animationSpeed={animationSpeed}
          clickHandler={orderNowClick}
          clickImageAnalytics={analyticsImageClick}
          isMobile={isMobile}
        />
      )}
    </div>
  );
};

RegionalMarketingComponent.propTypes = {
  contentData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object),
};

RegionalMarketingComponent.defaultProps = {
  history: {},
};

export default RegionalMarketingComponent;
